// extracted by mini-css-extract-plugin
export var link = "_uw-0";